export default __webpack_public_path__ + "static/media/res9.359601ab.PNG";